export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00674.bb038cdd.png";